import React from "react";
import cx from "clsx";
import styles from "./styles.module.scss";
import { getInitials } from "./utilities";
import { MSG_TYPE } from "../../../../config";

export const Message = ({ message, type, date, time, imageUrl, name }) => {
  const avatarStyle = imageUrl
    ? {
        background: `url(${imageUrl}) no-repeat center center / cover`,
      }
    : {};

  return (
    <div>
      <div className={styles.date}>
        <span>{date}</span>
      </div>
      <div
        className={cx(styles.wrapper, {
          [styles.wrapperFromMe]: type === MSG_TYPE.fromMe,
        })}
      >
        <div className={styles.avatar} style={avatarStyle}>
          {!imageUrl ? getInitials(name) : ""}
        </div>
        <div className={styles.info}>
          <div className={styles.name}>
            {name}, <span>{time}</span>
          </div>
          <div className={styles.message}>{message ? message : "‎"}</div>
        </div>
      </div>
    </div>
  );
};
